import { WorkTypes } from './../../../../shared/enums/work-types';
import { LocationTypes } from './../../../../shared/constants/location-types';
import { Component, OnInit, Output } from '@angular/core';
import { AppStore } from '../../../../shared/store/lookup-store.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { JobPost } from '../../../../jobs/models/job-post';
import { UiStateStore } from '../../../../shared/store/ui-state-store.service';
import { YearCount } from '../../../../shared/models/year-count';
import { Router } from '@angular/router';
import { AppLookupResponse } from '../../../../shared/models/app-lookup-response';
import { MultiSelectConfigHelper } from '../../../../shared/helpers/multi-select.config';
import { EmployerStore } from '../../../../dashboards/store/employer-store';
import { EventEmitter } from '@angular/core';
import { JobSkill } from '../../../../shared/models/job-skill';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'app-dashboard-employer-post-new-job',
  templateUrl: './dashboard-post-new-job.component.html',
  styleUrls: ['./dashboard-post-new-job.component.scss']
})
export class DashboardEmployerPostNewJobComponent implements OnInit {
  @Output() jobSaved = new EventEmitter<JobPost>();

  private today: Date = new Date();
  form: FormGroup;
  accountId: string;
  headerText: string = "Post a New Job";
  experienceYears: YearCount[] = [];
  locationTypes = LocationTypes;
  workTypes = WorkTypes;
  languagesList: AppLookupResponse[] = [];
  languageddlSettings = MultiSelectConfigHelper.getSettings('id', 'name');
  selectedLanguages = [];
  minExpiryDate = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() };

  _jobSkills: BehaviorSubject<JobSkill[]> = new BehaviorSubject<JobSkill[]>([]);
  jobSkills: Observable<JobSkill[]> = this._jobSkills.asObservable();

  constructor(public lookupStore: AppStore,
    public formBuilder: FormBuilder,
    public uiState: UiStateStore,
    public dataService: DataService,
    public employerStore: EmployerStore,
    private router: Router) {
    this.experienceYears = YearCount.list();
  }

  ngOnInit() {

    this.uiState.authenticatedUser.subscribe(user => {
      if (!user) {
        return;
      }

      this.accountId = user.accountId;
    });

    this.lookupStore.languages$.subscribe(resp => {
      this.languagesList = resp;
    })

    this.uiState.selectedJobId.subscribe(jobId => {
      if (!jobId) {
        return;
      }

      this.headerText = "Edit Job";

      this.dataService.getJobPost(jobId).subscribe(job => {
        if (!job) {
          return;
        }

        this._jobSkills.next(job.skills);
        let expiryDate = { year: job.expiryDate.getFullYear(), month: job.expiryDate.getMonth() + 1, day: job.expiryDate.getDate() };

        this.form.patchValue({ "id": job.id });
        this.form.patchValue({ "title": job.title });
        this.form.patchValue({ "description": job.description });
        this.form.patchValue({ "expiryDate": expiryDate });
        this.form.patchValue({ "educationLevel": job.educationLevel });
        this.form.patchValue({ "experience": job.experience });
        this.form.patchValue({ "sector": job.sector });
        this.form.patchValue({ "type": job.type });
        this.form.patchValue({ "salaryType": job.salaryType });
        this.form.patchValue({ "minimumSalary": job.minimumSalary });
        this.form.patchValue({ "maximumSalary": job.maximumSalary });
        this.form.patchValue({ "location": job.location });
        this.form.patchValue({ "createdByAccount": this.accountId });
        this.form.patchValue({ "city": job.city });
        this.form.patchValue({ "country": job.country });
        this.form.patchValue({ "workType": job.workType });
        this.form.patchValue({ "languages": job.languages });
      });
    });


    this.form = this.formBuilder.group({
      id: [''],
      title: ['', Validators.required],
      description: ['', Validators.required],
      expiryDate: ['', Validators.required],
      experience: ['', Validators.required],
      educationLevel: ['', Validators.required],
      sector: ['', Validators.required],
      type: ['', Validators.required],
      salaryType: ['', Validators.required],
      minimumSalary: ['', Validators.required],
      maximumSalary: ['', Validators.required],
      createdByAccount: [`${this.accountId}`],
      location: [''],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      workType: [null, Validators.required],
      languages: [0, Validators.required], // Default model
    });
  }

  save(): void {
    if (!this.form.valid) {
      return;
    }

    const jobPost = JobPost.parseForm(this.form);
    jobPost.skills = this.employerStore.getSkills().filter(skill => Object.values(skill).length > 0 && skill.title.length > 0);
    this.dataService.saveJobPost(jobPost).subscribe(jp => {
      this.jobSaved.emit(jp);
      //this.router.navigate(['./employer/manage-jobs']);
    });
  }

  onItemSelect = (selectedItem: AppLookupResponse) => {
    this.selectedLanguages.push(selectedItem);
  }

  onSelectAll = (selectedItems: AppLookupResponse[]) => {
    this.selectedLanguages = [] = selectedItems;
  }

  onDeSelect = (selectedItem: AppLookupResponse) => {
    const indexOf = this.selectedLanguages.findIndex(x => x.id == selectedItem.id);
    this.selectedLanguages.slice(indexOf);
  }

}
